import api from "../../../api/axios";

// Feature-local wrapper for the Client core GET used by the
// /clients/:clientId parent surface (Phase R2).
//
// Endpoint (per backend/app/apps/clients/views.py):
//   GET /api/crm/clients/{id}/    — IsClientAccessible (owner OR share).
//        Returns ClientDetailSerializer payload (full row + computed
//        `is_owner` / `can_edit` flags).
//
// Feature-local copy by convention: other features (clientEdit,
// clientActivity) keep their own identical wrappers. Phase R2 does NOT
// consolidate API wrappers — that is out of scope.
//
// Stateless request wrapper. No cache. No retry. No invalidation.

export const fetchClientById = (clientId, { signal } = {}) =>
  api.get(`/crm/clients/${clientId}/`, { signal }).then((res) => res.data);

// DELETE /api/crm/clients/{id}/ — IsClientOwnerOnly. Returns 204.
// Backend cascade per Django on_delete=CASCADE on dependent FKs
// (contacts, communications, shares, matches, viewings, tasks,
// preferences) — see backend/app/apps/clients/models.py.
//
// Phase S7 — T-4 destructive workflow (architecture-freeze-r8.md
// §4 T-4). Stateless request wrapper. No cache. No invalidation.
// No optimistic eviction. No event semantics. Caller is the parent
// (ClientDetailScreenContent); successor state is the user
// arriving on /clients with location.state.mayBeStale: true.

export const deleteClientById = (clientId) =>
  api.delete(`/crm/clients/${clientId}/`).then((res) => res.data);
